<h2 mat-dialog-title class="border-b border-mediumColor pb-3">
  @if (isAdd) {
    {{ 'SHARED_LABEL_ADD_MAPPING_RULE' | translate }}
  } @else {
    {{ 'SHARED_LABEL_EDIT_MAPPING_RULE' | translate }}
  }
</h2>
<mat-dialog-content>
  <div class="compact-theme">
    <em-mapping-rule-list
      class="mt-4 block"
      [sourceAttributes]="data.sourceAttributes"
      [customSourceAttributes]="data.customSourceAttributes"
      [destinationAttributes]="data.destinationAttributes"
      [operatorGroups]="availableOperatorGroups"
      [arrayIndex]="data.arrayIndex"
      [forceCustomWithoutFlag]="data.forceCustomWithoutFlag"
    ></em-mapping-rule-list>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="flex gap-2 p-4 pt-0">
    @if (isAdd) {
      <em-secondary-button color="danger" (btnClick)="close(true)">{{
        'ACTIONS_CANCEL' | translate
      }}</em-secondary-button>
      <em-primary-button (btnClick)="validateAndClose()">{{
        'SHARED_LABEL_ADD' | translate
      }}</em-primary-button>
    } @else {
      <em-secondary-button color="danger" (btnClick)="revertChanges()">{{
        'ACTIONS_CANCEL' | translate
      }}</em-secondary-button>
      <em-primary-button (btnClick)="validateAndClose()">{{
        'SHARED_LABEL_KEEP_CHANGES' | translate
      }}</em-primary-button>
    }
  </div>
</mat-dialog-actions>
